import { ContextModalProps } from '@mantine/modals'
import WorkForm from 'components/work/WorkForm'
import { useUpdateWork } from 'hooks/work'
import { UpdateWork } from 'types/work'

type Props = {
  initialValues: UpdateWork
}

export default function UpdateWorkModal({ context, id, innerProps: { initialValues } }: ContextModalProps<Props>) {
  const addWork = useUpdateWork()
  async function submitFabric(values: Omit<UpdateWork, 'id'>) {
    await addWork.mutateAsync({ ...values, id: initialValues.id })
  }

  return (
    <WorkForm
      onSubmit={submitFabric}
      onCancel={() => context.closeModal(id)}
      initialValues={initialValues}
      type="update"
    />
  )
}
